import { getApiInst } from '~/atoms/MangoApi'

import { createUserApi } from '@mangovoice/users'

export const userApi = createUserApi(getApiInst().getHttpTransport())
